import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { getActiveCompanySettings, logger } from '$utils'
import useWorkforceStore from '../../store'
import { AuthModule, PayrollSystem } from '$constants'
import { getStaffMemberAccess } from '../_common/access'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in AddStaffMember loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in AddStaffMember loader')

  const { payrollSystemPreference } = getActiveCompanySettings()
  const { canViewPayRates } = getStaffMemberAccess()

  // Nothing here needs to block the route transition, so all fetches are deferred.
  // The Xero-AU-only fetches depend on the connection check and run after it.
  const data = (async () => {
    const getPosStaffMembers = useWorkforceStore.getState().getPosStaff(false)

    const activeStaffMembers = useWorkforceStore.getState().activeStaffMembers
    const getStaffMembers =
      activeStaffMembers.length == 0
        ? useWorkforceStore.getState().getStaffMembers(false, false)
        : activeStaffMembers

    const getCompanyDefaultWorkingHours = useWorkforceStore
      .getState()
      .getCompanyDefaultWorkingHours()

    //Calendars exist in Xero AU and Xero NZ, so the check covers both
    const isXeroConnected =
      (payrollSystemPreference === PayrollSystem.XeroAu ||
        payrollSystemPreference === PayrollSystem.XeroNz) &&
      canViewPayRates() &&
      (await useWorkforceStore
        .getState()
        .checkThirdPartyConnectionStatus(AuthModule.Time))

    //Super funds and earnings rates are only available for XeroAu
    const isThirdPartyPayrollSystemConnected =
      isXeroConnected && payrollSystemPreference === PayrollSystem.XeroAu

    //A new staff member is always created at the active venue, so no venue to read through
    const getCalendars = isXeroConnected
      ? useWorkforceStore
          .getState()
          .getCalendars(payrollSystemPreference as PayrollSystem)
      : []

    //Only Xero AU needs details of possible super funds
    const getSuperFunds = isThirdPartyPayrollSystemConnected
      ? useWorkforceStore.getState().getSuperFunds()
      : []

    //Only XeroAu has earnings rates, which the connectivity check already covers
    const getEarningsRates = isThirdPartyPayrollSystemConnected
      ? useWorkforceStore
          .getState()
          .getEarningsRates(payrollSystemPreference as PayrollSystem)
      : []

    return Promise.all([
      getPosStaffMembers,
      getStaffMembers,
      getCalendars,
      getSuperFunds,
      getEarningsRates,
      getCompanyDefaultWorkingHours,
    ]).then(() => true)
  })().catch((error) => {
    logger.error('Add Staff Member Promise.all error', error)
    return false
  })

  return defer({ data })
}
